export const CupIcon = ({ className = "h-11" }) => (
  <img src="/logo-icon.png" alt="Ikon UPLINK COFFEE" className={`${className} w-auto shrink-0`} data-testid="brand-cup-icon" />
);

export const Logo = ({ small = false }) => (
  <div className="flex items-center gap-2.5 leading-none select-none" data-testid="header-brand-logo">
    <CupIcon className={small ? "h-9" : "h-10 sm:h-12"} />
    <div className="inline-flex flex-col">
      <div className={`font-serif font-bold tracking-tight text-ink ${small ? "text-2xl" : "text-3xl sm:text-4xl"}`}>UPLINK</div>
      <div className={`flex justify-between text-ink font-semibold px-[0.08em] ${small ? "text-[9px] mt-0.5" : "text-[10px] sm:text-xs mt-1"}`} aria-label="COFFEE" data-testid="logo-coffee-text">
        {"COFFEE".split("").map((c, i) => <span key={i} aria-hidden="true">{c}</span>)}
      </div>
    </div>
  </div>
);
